// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"Sidedrawer__SideDrawer__3P8No","Open":"Sidedrawer__Open__115Jt","Close":"Sidedrawer__Close__3VC0q","Logo":"Sidedrawer__Logo__3W_f1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidedrawer/Sidedrawer.css
// module id = 79
// module chunks = 3